import { Heading } from '@cinch-labs/design-system'
import styles from './section-title.module.css'

interface HeadingProps {
  title: string
}

export const SectionTitle: React.FC<HeadingProps> = ({ title }) => (
  <Heading element="h2" fontSize="h2" className={styles.sectionTitle}>
    {title}
  </Heading>
)
